import styled from 'styled-components'
import { VARIABLES } from '../../themes'
// import {
//   default as VARIABLES
// } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const SupplierDetailFormAdminStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  .main-content {
    min-height: calc(100vh - 267px);
  }

  .loading {
    justify-content: center;
    align-items: center;
  }

  .loader {
    border: 4px solid #3a39a8;
    border-radius: 50%;
    border-top: 4px solid #f3f3f3;
    width: 20px;
    height: 20px;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
  }

  .form-group {
    .checkbox {
      margin-right: 50px;
    }

    .form-group-control {
      .form-group-inner-wrapper {
        span {
          font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
          color: ${VARIABLES.COLORS.BLUE_1};

          &.approved {
            color: ${VARIABLES.COLORS.GREEN_1};
          }

          &.rejected {
            color: ${VARIABLES.COLORS.RED_3};
          }
        }
      }
    }

    &.sustainaility {
      .form-group-control {
        .form-group-inner-wrapper {
          height: 63px;

          span {
            margin-right: 30px;
            font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
            color: ${VARIABLES.COLORS.BLUE_1};

            &.incomplete {
              color: ${VARIABLES.COLORS.GRAY_9};
            }

            &.complete {
              color: ${VARIABLES.COLORS.GREEN_1};
            }
          }
        }
      }
    }

    &.supplier-nation {
      margin-bottom: 20px;
    }

    &.approve-status {
      .form-group-control {
        .form-group-inner-wrapper {
          align-items: flex-start;
          padding-top: 8px;
        }
      }
    }
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`
